const useColors = () => {
  const colors = {
    brand: {
      25: "#FAFAFF",
      50: "#F4F3FF",
      100: "#EBE9FE",
      200: "#D9D6FE",
      300: "#BDB4FE",
      400: "#9B9AFB",
      500: "#7A5AF8",
      600: "#693EEF",
      700: "#5925DC",
      800: "#4A1FB8",
      900: "#3E1C96",
      950: "#27115F",
    },
    grey: {
      25: '#FCFCFD',
      50: '#F8FAFC',
      100: '#EEF2F6',
      200: '#E2E8F0',
      300: '#CDD5DF',
      400: '#9AA4B2',
      500: '#697586',
      600: '#4B5565',
      700: '#364152',
      800: '#202939',
      900: '#121926',
      950: '#0D121C'
    },
    error: {
      25: "#FFF8FA",
      50: "#FDE3F2",
      100: "#FEE4E2",
      200: "#FECFCD",
      300: "#FDA29B",
      400: "#F97068",
      500: "#F04438",
      600: "#D92D20",
      700: "#B42318",
      800: "#912018",
      900: "#7A271A",
      950: "#55160C",
    },
    success: {
      25: "#F6FEF9",
      50: "#ECFDF3",
      100: "#D1FADF",
      200: "#A6F4C5",
      300: "#75E0A7",
      400: "#4CC38A",
      500: "#1EA977",
      600: "#079455",
      700: "#067E67",
      800: "#05603A",
      900: "#074D31",
      950: "#053221",
    },
    warning: {
      25: "#FFFCF5",
      50: "#FFF7EB",
      100: "#FEF0C7",
      200: "#FEDF89",
      300: "#FEC84B",
      400: "#FDB022",
      500: "#F79009",
      600: "#DC6803",
      700: "#B54708",
      800: "#93370D",
      900: "#7A2E0E",
      950: "#4E1D09",
    },
  };

  return {
    colors,
  };
};

export default useColors;
